import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'edu-admin-data-card',
  templateUrl: './admin-data-card.component.html',
  styleUrls: ['./admin-data-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AdminDataCardComponent {
  @Input('img') img: string;
  @Input('content') content: string;
  @Input('title') title: string;
  @Input() showNext: boolean = true;

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'arrow-right',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/arrow-right-grey.svg',
      ),
    );
  }
}
